import type { IconComponent } from "./types";

export const Google: IconComponent = ({ ref, color = "currentColor", ...props }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 25 24" ref={ref} {...props}>
      <title>Google</title>
      <path
        fill="#4285F4"
        fillRule="evenodd"
        d="M24.02 12.27c0-.85-.08-1.67-.22-2.45H12.5v4.64h6.46a5.52 5.52 0 0 1-2.4 3.62v3.01h3.88c2.27-2.09 3.58-5.16 3.58-8.82Z"
        clipRule="evenodd"
      />
      <path
        fill="#34A853"
        fillRule="evenodd"
        d="M12.5 24c3.24 0 5.96-1.07 7.94-2.9l-3.88-3.02a7.21 7.21 0 0 1-4.06 1.15 7.15 7.15 0 0 1-6.71-4.95H1.78v3.1A12 12 0 0 0 12.5 24Z"
        clipRule="evenodd"
      />
      <path
        fill="#FBBC05"
        fillRule="evenodd"
        d="M5.79 14.28a7.21 7.21 0 0 1 0-4.56v-3.1H1.78a12 12 0 0 0 0 10.77l4-3.11Z"
        clipRule="evenodd"
      />
      <path
        fill="#EA4335"
        fillRule="evenodd"
        d="M12.5 4.77c1.76 0 3.34.6 4.59 1.8l3.44-3.44A11.53 11.53 0 0 0 12.5 0 12 12 0 0 0 1.78 6.61l4 3.11a7.15 7.15 0 0 1 6.72-4.95Z"
        clipRule="evenodd"
      />
    </svg>
  );
};
Google.displayName = "Google";
